module.exports = __webpack_public_path__ + "static/media/fadedEmployeeIcon.710384ef.svg";